module.exports = __webpack_public_path__ + "img/p1-pic.656bedcd.jpg";